import { withBemMod } from '@bem-react/core';
import { cnSelect } from '../Select';
import './Select_width_max.css';
/**
 * Модификатор, отвечающий за максимальную ширину селекта.
 * @param {ISelectWidthMaxProps} props
 */
export var withWidthMax = withBemMod(cnSelect(), { width: 'max' });
